import { Box, Breadcrumbs, Button, IconButton, Link, Typography } from '@mui/material';
import { styled } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { CassinoAPI } from '../../../apis/CassinoAPI';
import TableCassinos from './components/TableCassinos';

const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    gap: 2,
});

const ReturnContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

const Header = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // backgroundColor: 'red'
});

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '1.2rem',
    fontWeight: '600',
}));

const CassinosView = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({
        visible: false,
        text: ""
    });

    const [cassinoList, setCassinoList] = useState([]);

    useEffect(() => {
        const fetchCassinos = () => {
            setAlert({ ...alert, visible: false });

            CassinoAPI.getCassinos()
                .then((res) => {
                    console.log(res);
                    setCassinoList(res);

                })
                .catch((e) => {
                    console.log(e);
                    setIsLoading(false);
                    setAlert({ visible: true, text: e.message });
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }

        fetchCassinos();

    }, []);

    return (
        <Container mt={-2}>
            <ReturnContainer ml={-3} mb={2}>
                <IconButton aria-label="voltar" onClick={() => navigate(`/admin`)}>
                    <ArrowBackIosIcon />
                </IconButton>
                <Typography color="text.primary">Voltar</Typography>
            </ReturnContainer>
            <Breadcrumbs aria-label="breadcrumb">
                <Link
                    underline="hover"
                    color="inherit"
                    href="/admin"
                >
                    Home
                </Link>
                <Link
                    underline="hover"
                    color="inherit"
                    href="/admin/gestao"
                >
                    Gestão
                </Link>
                <Typography color="text.primary">Cassinos</Typography>
            </Breadcrumbs>

            <Header mt={3}>
                <Title>Cassinos</Title>
                <Box>
                    <Button
                        onClick={() => navigate('/admin/gestao/cassinos/novo')}
                        variant="contained"
                        color="success"
                        size='small'
                        startIcon={<AddIcon />
                        }>
                        Novo cassino
                    </Button>
                </Box>
            </Header>

            <TableCassinos cassinos={cassinoList} />

        </Container>
    )
}
export default CassinosView;